import * as React from "react"
const SvgPaintBucket = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8.65 20.5 2.5 14.35a1.7 1.7 0 0 1-.375-.55 1.6 1.6 0 0 1 0-1.25q.125-.3.375-.55l5.75-5.725L6.375 4.4a1.1 1.1 0 0 1-.338-.775q-.012-.45.313-.8a1.05 1.05 0 0 1 .8-.35q.476 0 .825.35L17.15 12q.25.25.363.55a1.8 1.8 0 0 1-.001 1.25 1.5 1.5 0 0 1-.362.55L11 20.5a1.7 1.7 0 0 1-.55.375 1.61 1.61 0 0 1-1.25 0 1.7 1.7 0 0 1-.55-.375M9.825 7.85l-5.35 5.35h10.7zM19.8 21q-.9 0-1.525-.637-.625-.638-.625-1.563 0-.675.338-1.275.337-.6.762-1.175l.475-.6a.76.76 0 0 1 .587-.287.69.69 0 0 1 .588.262l.5.625q.4.575.75 1.175T22 18.8q0 .925-.65 1.563T19.8 21" />
  </svg>
)
export default SvgPaintBucket
